<script setup lang="ts">
import { StackLayout } from '@/components/Layouts'
import TypographyItem from '@/components/Typography/TypographyItem.vue'
import { EColors } from '@/types/constants/ColorValues'
import type { ExtendedPrimitives } from '@/types/ExtendedPrimitives'
import { useI18n } from 'vue-i18n'

type Props = {
    config?: Record<string, ExtendedPrimitives>
}
const props = defineProps<Props>()

const { t } = useI18n()

const keys = ['f1', 'f2']

const formatEIDString = (key: string) =>
    `EID : ${
        props.config?.[`${key}_evt_en`]
            ? props.config?.[`${key}_evt_val`] ?? t('common.undefined')
            : '-'
    }`

const formatTIDString = (key: string) =>
    `TID : ${
        props.config?.[`${key}_tmr_en`]
            ? props.config?.[`${key}_tmr_val`] ?? t('common.undefined')
            : '-'
    }`
</script>

<template>
    <StackLayout direction="column">
        <StackLayout v-for="(filter, key) in keys" :key="key">
            <StackLayout direction="row" :gap="8">
                <TypographyItem :label="`${filter.toUpperCase()} :`" />
                <TypographyItem
                    :label="formatEIDString(filter)"
                    :class="`has-text-${
                        config?.[`${filter}_evt_en`] ? EColors.SUCCESS : EColors.DANGER
                    }`" />
                <TypographyItem
                    :label="formatTIDString(filter)"
                    :class="`has-text-${
                        config?.[`${filter}_tmr_en`] ? EColors.SUCCESS : EColors.DANGER
                    }`" />
            </StackLayout>
        </StackLayout>
    </StackLayout>
</template>
